import React, { Component } from "react";
import Select from "react-select";

class InterestLaboralAreaSelect extends Component {
  state = {
    interest_laboral_area_select: [
      { value: "laboral_area_1", label: "Area Laboral 1" },
      { value: "laboral_area_2", label: "Area Laboral 2" },
      { value: "laboral_area_3", label: "Area Laboral 3" },
      { value: "laboral_area_4", label: "Area Laboral 4" },
      { value: "laboral_area_5", label: "Area Laboral 5" },
      { value: "laboral_area_6", label: "Area Laboral 6" },
    ]
  };

  handleChange = inputValue => {
    this.props.handleChange(inputValue, "interestLaboralArea");
  };

  render() {
    return (
      <Select
        inputId="idealLaboralArea"
        onChange={this.handleChange}
        options={this.state.interest_laboral_area}
        placeholder="Seleccione una opción"
        value={this.props.value}
      />
    );
  }
}

export default InterestLaboralAreaSelect;
